import React, { Component } from 'react';
import ReactDOM from 'react-dom';

interface Props {
	children: React.ReactNode;
}

/**
 * Renders children component within <body> element.
 */
export default class Portal extends Component<Props> {
	portalElement: HTMLDivElement = document.createElement('div');

	componentDidMount() {
		document.body.appendChild(this.portalElement);
	}

	componentWillUnmount() {
		document.body.removeChild(this.portalElement);
	}

	render() {
		return ReactDOM.createPortal(this.props.children, this.portalElement);
	}
}
